/* Eau Rouge promotion display, synchronized with Shopify's real automatic discount.
   Loaded only while the theme setting "Auto-sync promotion prices" is on.
   For the variants on the page it asks the Storefront API (a separate, anonymous cart that never touches the visitor's cart) what Shopify would charge.
   A promotion is shown only when Shopify reports a percentage discount on that exact variant, so inactive, not-yet-started, ended or ineligible discounts show nothing.
   Freshness rules (no polling when nothing is promoted or the tab is hidden):
   - an answer that contains a discount is trusted for 30 s, an answer without one for 120 s (a missed start is harmless, a stale promotion is not);
   - while a promotion is shown and the tab is visible, one re-check is scheduled when the answer expires;
   - the page is re-checked immediately when the tab becomes visible again, the window regains focus, or the page is restored from the back/forward cache;
   - every variant change re-checks that variant when its answer is no longer fresh;
   - if a re-check fails or no longer reports the discount, the regular price is restored at once.
   Checkout and the cart are always authoritative. */
(function () {
  var API = '/api/2026-07/graphql.json';
  var KEY = 'enzPromo4', TTL_PROMO = 30000, TTL_PLAIN = 120000, MIN_GAP = 5000;
  var Q = 'mutation($l:[CartLineInput!]!){cartCreate(input:{lines:$l}){cart{lines(first:250){nodes{merchandise{... on ProductVariant{id}} cost{subtotalAmount{amount}} discountAllocations{discountedAmount{amount}}}}} userErrors{message}}}';
  var SEL = '[data-product-price],[data-sticky-price]';
  var cache = {}, pending = {}, timer = null, lastReval = 0;
  try { cache = JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) { cache = {}; }

  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(cache)); } catch (e) {} }
  function toCents(a) { return Math.round(parseFloat(a) * 100); }
  function ttl(e) { return e.disc > 0 ? TTL_PROMO : TTL_PLAIN; }
  function fresh(id) { var e = cache[id]; return !!e && (Date.now() - e.t) < ttl(e); }
  function money(c) { return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function cents(s) { var m = (s || '').replace(/\s+/g, ' ').match(/(\d[\d,]*\.\d{2})/); return m ? Math.round(parseFloat(m[1].replace(/,/g, '')) * 100) : null; }
  function visible() { return document.visibilityState !== 'hidden'; }
  /* a percentage discount only: the amount must equal the rounded percentage of the regular price */
  function pctOf(e) {
    if (!e || !e.sub || !e.disc) return 0;
    var p = Math.round(e.disc / e.sub * 100);
    return (p >= 1 && p <= 99 && Math.abs(e.disc - Math.round(e.sub * p / 100)) <= 1) ? p : 0;
  }

  /* one real in-flight request per variant; callers wait for it. A failure is cached as "no discount" so the regular price shows. */
  function probe(ids, force) {
    var waits = [], todo = [];
    ids.forEach(function (id) {
      if (!id) return;
      if (pending[id]) { waits.push(pending[id]); return; }
      if (!force && fresh(id)) return;
      todo.push(id);
    });
    for (var i = 0; i < todo.length; i += 100) {
      (function (chunk) {
        var p = fetch(API, {
          method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ query: Q, variables: { l: chunk.map(function (id) { return { merchandiseId: 'gid://shopify/ProductVariant/' + id, quantity: 1 }; }) } })
        }).then(function (r) { if (!r.ok) throw new Error('http'); return r.json(); }).then(function (j) {
          var nodes = (((j.data || {}).cartCreate || {}).cart || {}).lines;
          nodes = nodes ? nodes.nodes : [];
          var got = {};
          nodes.forEach(function (n) {
            var id = String(n.merchandise.id).split('/').pop();
            var d = 0; (n.discountAllocations || []).forEach(function (a) { d += toCents(a.discountedAmount.amount); });
            cache[id] = { sub: toCents(n.cost.subtotalAmount.amount), disc: d, t: Date.now() };
            got[id] = 1;
          });
          chunk.forEach(function (id) { if (!got[id]) cache[id] = { sub: 0, disc: 0, t: Date.now() }; });
        }).catch(function () {
          chunk.forEach(function (id) { cache[id] = { sub: 0, disc: 0, t: Date.now() }; });   /* failure: fall back to the regular price */
        }).then(function () { chunk.forEach(function (id) { delete pending[id]; }); save(); });
        chunk.forEach(function (id) { pending[id] = p; });
        waits.push(p);
      })(todo.slice(i, i + 100));
    }
    return Promise.all(waits);
  }

  /* ---------- collection cards ---------- */
  function revertCard(el) {
    if (el.__enzOrig == null) return;
    el.innerHTML = el.__enzOrig; el.__enzOrig = null; el.__enzHtml = null; el.classList.remove('is--sale');
  }
  function applyCard(el) {
    var vid = el.getAttribute('data-enz-vid'), vprice = parseInt(el.getAttribute('data-enz-vprice'), 10), price = parseInt(el.getAttribute('data-enz-price'), 10);
    var e = cache[vid];
    if (!e) { revertCard(el); return; }
    if (!fresh(vid)) { if (el.__enzOrig == null) return; return; }   /* stale: keep what is shown until the next re-check; never start a promotion from stale data */
    var p = (e.sub === vprice) ? pctOf(e) : 0;
    if (!p || !price) { revertCard(el); return; }
    var final = (vprice === price) ? price - e.disc : price - Math.floor(price * p / 100)   /* Shopify rounds the discount amount down to the cent */;
    if (el.__enzOrig == null) el.__enzOrig = el.innerHTML;
    var from = !!(el.querySelector('.enz-price-from'));
    var html = '<del data-enz-promo>' + money(price) + '</del><ins class="enz-price-now">' + (from ? '<span class="enz-price-from">From</span> ' : '') + money(final) + '</ins><span class="enz-sale-badge" data-enz-promo>' + p + '% OFF</span>';
    if (!el.querySelector('[data-enz-promo]') || el.__enzHtml !== html) { el.__enzHtml = html; el.innerHTML = html; }
    el.classList.add('is--sale');
  }
  function cardEls() { return Array.prototype.slice.call(document.querySelectorAll('.enz-card-price[data-enz-vid]')); }
  function refreshCards(force) {
    var els = cardEls(), ids = [];
    els.forEach(function (el) { var v = el.getAttribute('data-enz-vid'); if (ids.indexOf(v) < 0) ids.push(v); });
    if (!force) els.forEach(applyCard);
    return probe(ids, force).then(function () { els.forEach(applyCard); });
  }

  /* ---------- product page price, sticky bar, quick view ---------- */
  function vid() {
    var u = new URLSearchParams(location.search).get('variant');
    if (u) return u;
    var f = document.querySelector('form[action*="/cart/add"] [name=id]');
    return f ? f.value : null;
  }
  function pdpEls() { return Array.prototype.slice.call(document.querySelectorAll(SEL)); }
  function shown(el) { return !!el.querySelector('[data-enz-promo]'); }
  function setLive() { document.body.classList.toggle('enz-promo-live', pdpEls().some(function (el) { return shown(el) && !el.hasAttribute('data-sticky-price'); })); }
  function showPromo(el, c, e, p) {
    var sticky = el.hasAttribute('data-sticky-price');
    var html = '<del data-enz-promo class="enz-pdp-promo">' + money(c) + '</del> <ins>' + money(c - e.disc) + '</ins>' + (sticky ? '' : ' <span class="enz-promo-badge" data-enz-promo>' + p + '% OFF</span>');
    if (!shown(el) || el.__enzHtml !== html) { if (!shown(el)) el.__enzPlain = el.innerHTML; el.__enzHtml = html; el.innerHTML = html; }   /* also re-write after the theme replaced the price with plain text */
  }
  function restorePlain(el) {
    if (!shown(el)) return;
    el.__enzHtml = null;
    el.innerHTML = el.__enzPlain != null ? el.__enzPlain : money(cents(el.querySelector('del').textContent));
  }
  /* decide what the element should show right now, from fresh answers only */
  function render(el, retry) {
    if (shown(el)) {
      var c0 = cents(el.querySelector('del').textContent), v0 = vid();
      if (v0 && !fresh(v0)) { probe([v0]).then(function () { render(el); setLive(); schedule(); }); return; }   /* expired answer: re-check, then decide */
      var e0 = v0 ? cache[v0] : null, p0 = (e0 && e0.sub === c0) ? pctOf(e0) : 0;
      if (p0) showPromo(el, c0, e0, p0); else restorePlain(el);
      return;
    }
    if (el.querySelector('del')) return;                       /* a real compare-at sale rendered by the theme: leave it */
    var c = cents(el.textContent);
    if (c === null || /\bfrom\b/i.test(el.textContent)) return;
    var v = vid(), e = v && fresh(v) ? cache[v] : null, p = (e && e.sub === c) ? pctOf(e) : 0;
    if (p) { showPromo(el, c, e, p); return; }
    if (v && !fresh(v)) {
      probe([v]).then(function () { if (!shown(el) && cents(el.textContent) === c) render(el, retry); setLive(); schedule(); });
    } else if (v && e && e.sub !== c && !retry) {
      setTimeout(function () { render(el, true); }, 500);       /* the URL may lag behind a variant change */
    }
  }
  function watch(el) {
    if (el.__enzPromo) return;
    el.__enzPromo = true;
    var n = 0, t0 = Date.now(), mo = new MutationObserver(function () {
      if (Date.now() - t0 > 2000) { n = 0; t0 = Date.now(); }
      if (++n > 40) { mo.disconnect(); return; }                /* safety valve: never loop */
      render(el); setLive(); schedule();
    });
    mo.observe(el, { childList: true, subtree: true, characterData: true });
    render(el); setLive();
  }
  function scan(root) { (root.querySelectorAll ? root.querySelectorAll(SEL) : []).forEach(watch); }

  /* ---------- freshness: re-check on return, on focus, on expiry ---------- */
  function anyShown() {
    return cardEls().some(function (el) { return el.__enzOrig != null; }) || pdpEls().some(shown);
  }
  function revalidate() {
    if (Date.now() - lastReval < MIN_GAP) return Promise.resolve();
    lastReval = Date.now();
    var ids = [];
    cardEls().forEach(function (el) { var v = el.getAttribute('data-enz-vid'); if (ids.indexOf(v) < 0) ids.push(v); });
    var pv = vid(); if (pv && pdpEls().length && ids.indexOf(pv) < 0) ids.push(pv);
    return probe(ids, true).then(function () {
      cardEls().forEach(applyCard);
      pdpEls().forEach(function (el) { render(el); });
      setLive(); schedule();
    });
  }
  /* one-shot timer, only while something is promoted and the tab is visible */
  function schedule() {
    if (timer) { clearTimeout(timer); timer = null; }
    if (!visible() || !anyShown()) return;
    timer = setTimeout(function () { timer = null; revalidate(); }, TTL_PROMO);
  }
  document.addEventListener('visibilitychange', function () { if (visible()) revalidate(); else if (timer) { clearTimeout(timer); timer = null; } });
  window.addEventListener('focus', function () { revalidate(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { lastReval = 0; revalidate(); } });

  scan(document);
  refreshCards(false).then(function () { setLive(); schedule(); });
  new MutationObserver(function (muts) {
    var added = false;
    muts.forEach(function (m) { m.addedNodes.forEach(function (n) {
      if (n.nodeType !== 1) return;
      if (n.closest && n.closest('.enz-card-price,[data-product-price],[data-sticky-price]') && !(n.matches && n.matches('.enz-card-price,' + SEL))) return;
      added = true; if (n.matches && n.matches(SEL)) watch(n); scan(n);
    }); });
    if (added) refreshCards(false);
  }).observe(document.body, { childList: true, subtree: true });
})();
